import { render, staticRenderFns } from "@/agilis/components/DataTableV2/DataTableV2ItemEdit/DataTableV2ItemEdit.html?vue&type=template&id=205fd2eb&scoped=true&external"
import script from "./PriceItemTableEdit.js?vue&type=script&lang=js&external"
export * from "./PriceItemTableEdit.js?vue&type=script&lang=js&external"
import style0 from "@/agilis/components/DataTableV2/DataTableV2ItemEdit/DataTableV2ItemEdit.css?vue&type=style&index=0&id=205fd2eb&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205fd2eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
installComponents(component, {VBtn,VCard})
